"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPermission = exports.willPromptForPermission = exports.getPermissionState = void 0;
const toolbox_1 = require("@streem/toolbox");
const BROWSER_PERMISSIONS = {
    // @ts-ignore Bug in TypeScript dom-lib 4.4, this code is valid and typescript is wrong: https://githubmemory.com/repo/microsoft/TypeScript-DOM-lib-generator/issues/1029
    CAMERA: 'camera',
    LOCATION: 'geolocation',
    // @ts-ignore Bug in TypeScript dom-lib 4.4, this code is valid and typescript is wrong: https://githubmemory.com/repo/microsoft/TypeScript-DOM-lib-generator/issues/1029
    MICROPHONE: 'microphone',
};
function getPermissionState(permission) {
    return __awaiter(this, void 0, void 0, function* () {
        (0, toolbox_1.invariant)('permissions' in navigator, 'Permissions API must be supported to check permission status');
        const browserPermission = BROWSER_PERMISSIONS[permission];
        (0, toolbox_1.invariant)(browserPermission, `Permission not yet supported: ${permission}`);
        const permissionStatus = yield navigator.permissions.query({ name: browserPermission });
        return permissionStatus.state;
    });
}
exports.getPermissionState = getPermissionState;
function willPromptForPermission(permission) {
    return __awaiter(this, void 0, void 0, function* () {
        const permissionState = yield getPermissionState(permission);
        return permissionState === 'prompt';
    });
}
exports.willPromptForPermission = willPromptForPermission;
function hasPermission(permission) {
    return __awaiter(this, void 0, void 0, function* () {
        const permissionState = yield getPermissionState(permission);
        return permissionState === 'granted';
    });
}
exports.hasPermission = hasPermission;
//# sourceMappingURL=permission_state.js.map